// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"142af5a0","95":"cfe79159","646":"50c73f10","787":"f0004aed","829":"199227a8"}[chunkId] + ".chunk.js";
};